// extracted by mini-css-extract-plugin
export var button = "_l-0";
export var buttonContent = "_l-e";
export var buttonGroup = "_l-c";
export var dontRestrainIconWidth = "_l-a";
export var dropdownButton = "_l-b";
export var iconContainer = "_l-9";
export var lg = "_l-4";
export var md = "_l-3";
export var pending = "_l-f";
export var sm = "_l-2";
export var spinner = "_l-d";
export var squared = "_l-8";
export var wrapText = "_l-g";
export var xl = "_l-5";
export var xs = "_l-1";
export var xxl = "_l-6";
export var xxxl = "_l-7";